import { render, staticRenderFns } from "./OfertaAcademica.vue?vue&type=template&id=2929fc97&scoped=true"
import script from "./OfertaAcademica.vue?vue&type=script&lang=js"
export * from "./OfertaAcademica.vue?vue&type=script&lang=js"
import style0 from "./OfertaAcademica.vue?vue&type=style&index=0&id=2929fc97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929fc97",
  null
  
)

export default component.exports